// extracted by mini-css-extract-plugin
module.exports = {"ChatDealListPane":"ChatDealListPane_ChatDealListPane__sGe0j","TitleWrapper":"ChatDealListPane_TitleWrapper__rbECW","Title":"ChatDealListPane_Title__05WlL"};